import { Box } from "@mui/material"
import { IRootState } from "app/model"
import React from "react"
import { connect } from "react-redux"
import { IUIConfiguration } from "ui/configuration/model"
import { UI_THEMES } from "ui/model"
import { getLogoUrl } from "ui/tools/logo"

export interface ILogoProps extends ILogoConnectProps {
  id?: string
  useTrunkedImage?: boolean
  sx?: any
}

export interface ILogoConnectProps {
  isDarkTheme: boolean
  config: IUIConfiguration // used to trigger a refresh
}

export const LogoFn = React.memo(({ id, isDarkTheme, useTrunkedImage, sx }: ILogoProps): JSX.Element => {
  const url = getLogoUrl(useTrunkedImage || false, isDarkTheme)
  return (
    <Box
      id={id}
      sx={{
        width: "14rem",
        height: "5.25rem",
        backgroundPosition: "center",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundImage: `url(${url})`,
        transition: "all 400ms ease",
        ...sx
      }}
    />
  )
})

export const Logo = connect(
  (state: IRootState): ILogoConnectProps => ({
    isDarkTheme: (state.ui.theme as any).palette.type === UI_THEMES.DARK,
    config: state.ui.config
  })
)(LogoFn)
